/// <reference types="vite/client" />
import * as Sentry from '@sentry/vue';

export type SentryPluginOptions = {
  dsn?: string;
  environment?: string;
};

const SENSITIVE_HEADERS = ['authorization', 'cookie', 'x-csrf-token'];

const FILTERED = '[Filtered]';

const isE2ETest = typeof import.meta !== 'undefined' && import.meta.env?.VITE_E2E === 'true';

function scrubHeaders(headers: Record<string, any> | undefined): void {
  if (!headers) return;
  for (const key of Object.keys(headers)) {
    if (SENSITIVE_HEADERS.includes(key.toLowerCase())) {
      headers[key] = FILTERED;
    }
  }
}

function scrubAuth(event: Sentry.Event): Sentry.Event {
  scrubHeaders(event?.request?.headers as Record<string, any> | undefined);
  if (Array.isArray(event?.breadcrumbs)) {
    for (const bc of event.breadcrumbs) {
      scrubHeaders((bc?.data as any)?.headers);
    }
  }
  return event;
}

export const sentryPlugin = {
  install(Vue: any, options: SentryPluginOptions = {}) {
    if (isE2ETest) {
      return;
    }
    const { dsn, environment } = options;
    if (!dsn) {
      return;
    }
    Sentry.init({
      Vue,
      dsn,
      environment,
      tracesSampleRate: 0,
      beforeSend(event) {
        return scrubAuth(event);
      }
    });
  }
};
